import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface PdfPreviewDialogData {
  title: string;
  fileName: string;
  url: string;
}

@Component({
  selector: 'app-pdf-preview-dialog',
  templateUrl: './pdf-preview-dialog.component.html',
  styleUrls: ['./pdf-preview-dialog.component.scss'],
})
export class PdfPreviewDialogComponent implements OnInit, OnDestroy {
  safeUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<PdfPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PdfPreviewDialogData,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
  }

  ngOnDestroy(): void {
  }

  close(): void {
    this.dialogRef.close();
  }
}